import "./style.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from './router/index.js'

// Interceptar todas las peticiones y redirigir al signup si la respuesta es 401
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401) {
    // Opcional: limpiar token almacenado
    localStorage.removeItem('dq-token');
    router.push({ name: 'SignUp' });
  }
  return response;
};

createApp(App).use(router).mount("#app");
